import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enCommon from "./locales/en/common.json";
import esCommon from "./locales/es/common.json";
import ptCommon from "./locales/pt-BR/common.json";

const STORAGE_KEY = "nexus_admin_lang";

function resolveInitialLanguage() {
  if (typeof window === "undefined") return "en";
  const stored = window.localStorage.getItem(STORAGE_KEY);
  if (stored) return stored;
  return "en";
}

i18n.use(initReactI18next).init({
  resources: {
    en: { common: enCommon },
    "pt-BR": { common: ptCommon },
    es: { common: esCommon },
  },
  lng: resolveInitialLanguage(),
  fallbackLng: "en",
  defaultNS: "common",
  interpolation: { escapeValue: false },
});

export function setLanguage(value: string) {
  if (typeof window !== "undefined") {
    window.localStorage.setItem(STORAGE_KEY, value);
  }
  void i18n.changeLanguage(value);
}

export default i18n;
